/**
 * @author      calvin@zumper.com (Calvin Yau)
 * @copyright   Copyright (c) 2019, Zumper
 * @description Flag modal constants
 */

export const RECEIVE_DATA = '@@nzr/modals/flagModal/RECEIVE_DATA'
